const STORAGE_KEY = 'sentry_journey_breadcrumbs';

const MAX_JOURNEY_BREADCRUMBS = 50;

/**
 * Append a breadcrumb to the persisted, capped ring buffer.
 *
 * Failures are swallowed so they never block the breadcrumb itself.
 */
export function persistJourneyBreadcrumb(breadcrumb) {
  if (!breadcrumb) {
    return;
  }

  try {
    const stored = readJourneyBreadcrumbs();

    stored.push(breadcrumb);

    const trimmed = stored.slice(-MAX_JOURNEY_BREADCRUMBS);

    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(trimmed));
  } catch {}
}

/**
 * Read the persisted journey breadcrumbs, falling back to an empty list.
 */
export function readJourneyBreadcrumbs() {
  try {
    const parsed = JSON.parse(sessionStorage.getItem(STORAGE_KEY) || '[]');

    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}
